<template>
  <div class="partner">
    <img
      src="https://bernouly.oss-cn-beijing.aliyuncs.com/xtyr/banner.png"
      alt="协同育人"
      style="width: 100%"
    />
    <div class="certificate-list">
      <div class="certificate-list-left">
        <div class="toobar">
          <div class="eng">EDUCATION</div>
          <div class="eng-font">协同育人</div>
        </div>

        <ul>
          <li v-for="(item, index) in certificateItems" :key="index">
            <div
              :class="pindex == index ? 'column2' : 'column1'"
              @click="showToggle(item)"
            >
              {{ item.name }}
              <span
                v-if="pindex == item"
                style="float: right; margin-right: 20px"
                >></span
              >
            </div>
            <ul v-if="item.name == '申报指南'" v-show="item.isSubShow">
              <li style="padding-left: 20px">
                <div style="height: 10px"></div>
                <a @click="rdio(0)" style="cursor: pointer">
                  <div :class="radoFlag == 0 ? 'rado1' : 'rado'">2021年</div>
                </a>
                <br />
                <a @click="rdio(1)" style="cursor: pointer">
                  <div :class="radoFlag == 1 ? 'rado1' : 'rado'">2022年</div>
                </a>
                <a @click="rdio(4)" style="cursor: pointer">
                  <div :class="radoFlag == 4 ? 'rado1' : 'rado'">2024年</div>
                </a>
                <div style="height: 10px"></div>
              </li>
            </ul>

            <ul v-if="item.name == '课程成果展示'" v-show="item.isSubShow">
              <li style="padding-left: 20px">
                <div style="height: 10px"></div>
                <a @click="rdio(2)" style="cursor: pointer">
                  <div :class="radoFlag == 2 ? 'rado1' : 'rado'">2021年</div>
                </a>
                <br />
                <a @click="rdio(3)" style="cursor: pointer">
                  <div :class="radoFlag == 3 ? 'rado1' : 'rado'">2022年</div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <br />
        <!-- <div class="column1">
          <div>考证信息</div>
        </div>-->
      </div>

      <div class="certificate-list-right">
        <div v-if="radoFlag == 0" class="certificate-info">
          <div class="r_title">
            <p style="white-space: nowrap">
              2021年博努力（北京）仿真技术有限公司
            </p>
            <p>&nbsp;&nbsp;教育部产学合作协同育人项目申报指南</p>
          </div>
          <div
            class="content"
            style="
              font-size: 16px;
              margin-top: 57px;
              color: #777777;
              font-family: siyuanx;
              text-indent: 43px;
              line-height: 37px;
            "
          >
            近日，《教育部高等教育司2021年工作要点》指出，将深入推进新工科、新医科、新农科、新文科建设，促进“四新”交叉融合，提升国家硬实力、全民健康力、生态成长力和文化影响力。其中，持续实施产学合作协同育人项目是全面深化新工科建设的重要举措之一。
            <br />
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;博努力（北京）仿真技术有限公司成立于2012年，注册资金3000万元，总部位于北京，在郑州、武汉等地设立了分支机构。是一家以仿真技术、虚拟现实和网络技术为手段，面向电力、能源、化工、建材等工业领域，提供工艺系统仿真、控制系统设计验证、职业技能培训、虚拟实验、数字化教学资源库等整体解决方案的高新技术企业。公司被教育部批准为1+X垃圾焚烧发电运行与维护、发电集控运维职业技能培训评价组织。截止到2020年，博努力（北京）仿真技术公司已达成合作院校100余所，培训学生10万余人，培训师资600余人。
            <br />
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2021年博努力（北京）仿真技术有限公司拟在新能源领域对“新能源虚拟仿真实验教学课程设计与应用”、“新能源方向教学内容和课程体系改革”两个方面与高校开展紧密合作，具体内容如下：
            <br />
            <br />
            <div
              style="
                color: black;
                font-family: 微软雅黑, sans-serif;
                font-size: 15px;
                font-weight: bold;
              "
            >
              一、建设目标
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在教育部指导下，博努力（北京）仿真技术有限公司提供全方位的教育教学改革服务，积极开展协同育人项目，促进高校在开展教学内容和课程体系改革过程中，围绕新能源产业的热点技术，包括综合能源站、储能系统、制冷、制热、分布式发电、智能微电网等课程方向，不断优化课程体系，提升教学质量，培养适应产业发展需要的具有创新精神和实践能力的高质量、复合型人才，建成一批高质量、可共享的虚拟仿真实验教学方案、课程教案和教学改革方案。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              二、项目内容
            </div>

            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （一）新能源虚拟仿真实验教学课程设计与应用建设项目
            </div>
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;拟设立10个项目，面向国内本科高校新能源专业，包含综合能源站、储能系统、制冷、制热、分布式发电、智能微电网等课程方向，开展新能源虚拟仿真实验教学课程设计与应用项目建设。根据对应专业的培养计划提供虚拟仿真实验教学课程建设内容、功能需求分析、编写实验脚本、教学设计、软件修改或优化改进意见、实验指导书编写、专业咨询等工作。虚拟仿真实验教学课程建设要有其必要性，最好为真实实验无法开展、存在困难、难以达到教学效果的实验。
            <br />

            <br />
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （二）新能源教学内容和课程体系改革项目
            </div>
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;拟设立10个项目，面向国内本科高校新能源专业，支持教学方式方法创新与改革，分享教学改革经验和实践做法。拟支持的方向包含综合能源站、储能系统、制冷、制热、分布式发电、智能微电网等课程教学方向，形成相应的教材、课程、方案等资源。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              三、申报条件
            </div>

            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （一）新能源虚拟仿真实验教学课程设计与应用建设项目
            </div>
            <br />1.项目申报人为本科实验教学课程负责人；
            <br />2.申报课程应以现有课程为基础，要求该课程至少已开设2年以上。不接受之前没有开课基础的课程申报；
            <br />3.申报课程学时安排应不少于32学时，平均每年开课次数不少于一次。同等条件下，优先考虑受益面大的课程申报。
            <br />
            <br />
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （二）新能源教学内容和课程体系改革项目
            </div>
            <br />1.项目申报人为本科教学工作课程负责人；
            <br />2.申报课程方向主要是综合能源站、储能系统、制冷、制热、分布式发电、智能微电网等，至少已开设3年以上；
            <br />3.申报课程已有一些可公开、可共享的教学改革方案，且教改方案有完整的开发资料，不仅限于发表教改论文。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              四、建设要求
            </div>
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （一）新能源虚拟仿真实验教学课程设计与应用建设项目
            </div>
            <br />1.成果须包含课程内容和典型教学案例两部分，形成完整的项目建设内容，且明确注明可公开、可共享。
            <br />2.课程大纲，包括具体的课程时间分配、实验原理、实验方法、实验步骤描述；
            <br />3.教师授课教案：每章节均提供PPT课件。提供课程相关的参考书目、论文参考文献、网络资源等内容；
            <br />4.典型教学案例：围绕课程教学内容，开发5个典型教学案例。
            <br />
            <br />
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （二）新能源教学内容和课程体系改革项目
            </div>
            <br />1.所有数字资源，包含.doc或.ppt形式的文件；
            <br />2.教改方案或执行报告，可以以论文形式呈现；
            <br />3.若有源代码，请给出源代码文件；
            <br />4.请明确注明可公开、可共享。
            <br />5.博努力（北京）公司对所开发课程成果不拥有任何知识产权。
            <br />项目支持的所有课程资源均要求在学校自己网站上进行共享，且可给其他所有学校免费使用，促进教学资源共享。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              五、支持办法
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;拟支持10项新能源虚拟仿真实验课程建设项目（包含综合能源站、储能系统、制冷、制热、分布式发电、智能微电网等方向）、10项新能源教学内容和课程体系改革项目。建设周期均从立项日期起为期一年。
            <br />
            <br />1.经费：博努力（北京）仿真技术有限公司拟对入选的虚拟仿真实验课程建设项目每个5万元人民币经费支持，拟对入选的新能源教学内容和课程体系改革项目每个5万元人民币经费支持。
            <br />2.博努力（北京）仿真技术有限公司将为立项项目提供必要的支持。在项目开展的一年期内，保持双向沟通和交流，促进建设项目的顺利进行。
            <br />3.博努力（北京）仿真技术有限公司将在项目结束之际，组织项目评审，并且对项目进行总结，巩固建设成果，为公开共享建设成果做好必要准备。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              六、申请办法
            </div>
            1.申报者应在产学合作协同育人平台（http://cxhz.hep.com.cn）注册教师用户，填写申报相关信息，并下载《2021年博努力（北京）仿真技术有限公司教育部产学合作协同育人项目申报书》进行填写。
            <br />2.项目申报人须在平台项目申报截止时间前将加盖高校校级主管部门公章的申请书形成PDF格式电子文档（无需提供纸质文档）上传至平台。若有任何疑问，请与企业项目负责人联系。
            <br />
            <p>企业项目负责人：许加达</p>
            <p>电话：13466405155</p>
            <p>邮箱：bernouly@126.com</p>
            3.博努力（北京）仿真技术有限公司将于项目申报结束后组织专家进行项目评审，并及时公示入选项目名单。
            <br />4.
            博努力（北京）仿真技术有限公司将与项目申报负责人所在高校签署立项项目协议书。立项项目周期为1年，所有工作应在立项项目协议书约定的项目周期内完成。项目到期后，项目负责人通过项目平台提交结题报告及项目成果，博努力（北京）仿真技术有限公司将对项目进行验收。
          </div>
        </div>
        <div v-if="radoFlag == 1" class="certificate-info">
          <div class="r_title">
            <p style="white-space: nowrap">
              2022年博努力（北京）仿真技术有限公司
            </p>
            <p>&nbsp;&nbsp;教育部产学合作协同育人项目申报指南</p>
          </div>
          <div
            class="content"
            style="
              font-size: 16px;
              margin-top: 57px;
              color: #777777;
              font-family: siyuanx;
              text-indent: 43px;
              line-height: 37px;
            "
          >
            近日，《教育部高等教育司2021年工作要点》指出，将深入推进新工科、新医科、新农科、新文科建设，促进“四新”交叉融合，提升国家硬实力、全民健康力、生态成长力和文化影响力。其中，持续实施产学合作协同育人项目是全面深化新工科建设的重要举措之一。
            <br />
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;博努力（北京）仿真技术有限公司（以下简称博努力）是以计算机数值模拟仿真技术、虚拟现实技术和网络技术为核心，面向电力、能源、化工、建材等工业领域，提供工艺系统仿真、控制系统设计验证、职业技能培训、虚拟实验开发、数字化教学资源库建设等整体解决方案的高新技术企业，致力于虚拟仿真、数字孪生、云计算等技术在高校实验室建设中的应用与推广。博努力被教育部批准为1+X垃圾焚烧发电运行与维护、发电集控运维职业技能培训评价组织。截止到2021年，博努力（北京）仿真技术公司已达成合作院校100余所，培训学生12万余人，培训师资800余人。
            <br />
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2022年博努力提供经费及软硬件支持总价值300万元，拟在“新能源”、“数字孪生”、“能源产品与市场”领域与高校展开紧密合作，具体内容如下：
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              一、建设目标
            </div>

            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在教育部高教司指导下，开展产学合作协同育人项目，包含教学内容和课程体系改革、实践条件和实践基地建设项目两大类。
            <br />
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;教学内容和课程体系改革项目围绕新能源领域的热点技术，包括风力、光伏发电、氢能发电、综合能源站、储能系统、制冷、制热、分布式发电、智能微电网、数字孪生、能源产品与市场、新材料、建材绿色生产等课程方向，不断优化课程体系，提升教学质量，培养适应产业发展需要的具有创新精神和实践能力的高质量、复合型人才，建成一批高质量、可共享的虚拟仿真实验教学方案、课程教案和教学改革方案。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;实践条件和实践基地建设项目围绕“虚拟仿真实验资源平台”、“多学科仿真平台”，支持高校学生进行针对风力、光伏发电、氢能、分布式发电、智能微电网、数字孪生、能源产品与市场、建材绿色生产等方向的仿真算法研究，联合高校建设“校企共建虚拟仿真实验教学中心”、打造“国家级虚拟仿真实验教学一流课程”，开展相应领域的虚拟仿真实验教学内容共同研发活动。校企推动重新构建相关课程实验教学内容，优化实践体系，丰富培养方案，提升育人质量，推动高校应用型、创新型、复合型人才培养。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              二、项目内容
            </div>

            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （一）教学内容和课程体系改革项目
            </div>
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;拟设立35个项目，面向国内本科高校新能源、数字孪生、能源产品与市场、建材绿色生产专业，包含风力、光伏发电、氢能发电、综合能源站、储能系统、制冷、制热、分布式发电、智能微电网、数字孪生、能源产品与市场、新材料、建材绿色生产等课程方向，开展新能源及数字孪生虚拟仿真实验教学课程设计与应用项目建设。根据对应专业的培养计划提供虚拟仿真实验教学课程建设内容、功能需求分析、编写实验脚本、教学设计、软件修改或优化改进意见、实验指导书编写、专业咨询等工作，支持教学方式方法创新与改革，分享教学改革经验和实践做法，形成相应的虚拟实验系统、教学软件、教材、课程、方案等资源。方向及内容最好为真实实验无法开展、存在困难、难以达到教学效果的实验，促进相关专业与企业合作重新构建有专业深度的教学内容，优化实验教学体系，拉近产学距离，提升育人质量。
            <br />

            <br />
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （二）实践条件和实践基地建设项目
            </div>
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;拟设立5个项目，专业方向面向国内本科高校新能源、数字孪生、能源产品与市场、建材绿色生产专业，用于建设基于互联网的虚拟实验在线自主开发平台及实验项目。由博努力提供相关专业课程的虚拟仿真教学或实验软件及管理平台，联合高校共建共管虚拟仿真实验教学中心，开展相应课程虚拟仿真实验教学应用，重构和优化相关课程实验教学内容，校企联合制定实验教学培养方案，提升育人质量，推动高校相关专业应用型、创新型、复合型人才培养。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              三、申报条件
            </div>

            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （一）教学内容和课程体系改革项目
            </div>
            <br />（1）教师提供课程体系结构，知识体系，课程内容，典型教学案例。面向高校新能源、数字孪生、能源产品与市场、建材绿色生产方向的本科院系，由高校各学科建设团队自由申报。
            <br />（2）确保有足够时间按时完成项目建设和交付，有志于进行教学内容改革、完善课程体系，并进行过类似研究，或已经有完善的研究计划，能够代表该课程在行业内容最新发展方向。
            <br />（3）院校领导大力支持推进高校课程综合改革，申报单位和企业按比例投入配套相关经费用于项目建设。
            <br />（4）项目申报人为本科实验教学课程负责人。
            <br />（5）申报课程应以现有课程为基础，不接受之前没有开课基础的课程申报。同等条件下，优先考虑受益面大的课程申报。
            <br />
            <br />
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （二）实践条件和实践基地建设项目
            </div>
            <br />（1）教师团队提供课程体系结构，知识体系，课程内容，典型教学案例。面向高校新能源、数字孪生、能源产品与市场、建材绿色生产方向的本科院系，由高校各学科建设团队自由申报。
            <br />（2）申报高校应具备与课程配套的相关实训实验环境或具备相关领域算法方面的课题研究经验。
            <br />（3）优先考虑国家级或省级实验教学示范中心/虚拟仿真实验教学中心的申报单位。
            <br />注意：每位老师请申报上述项目中的一项，不鼓励多项申报。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              四、建设要求
            </div>
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （一）教学内容和课程体系改革项目
            </div>
            <br />（1）成果须包含课程内容和典型教学案例两部分，形成完整的项目建设内容，且明确注明可公开、可共享。
            <br />（2）课程大纲，包括具体的课程时间分配、实验原理、实验方法、实验步骤描述；
            <br />（3）教师授课教案：每章节均提供PPT课件。提供课程相关的参考书目、论文参考文献、网络资源等内容；
            <br />（4）典型教学案例：围绕课程教学内容，开发5个典型教学案例。
            <br />（5）教改方案或执行报告，可以以论文形式呈现；所有数字资源，包含.doc或.ppt形式的文件；若有源代码，请给出源代码文件。
            <br />（6）博努力对所开发课程成果不拥有任何知识产权。项目支持的所有课程资源均要求在学校自己网站上进行共享，且可给其他所有学校免费使用，促进教学资源共享。
            <br />
            <br />
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （二）实践条件和实践基地建设项目
            </div>
            <br />（1）校方应具备不少于 30 人同时做实验的实验基地。
            <br />（2）基于博努力公司的多学科仿真平台，提供实验手册或实验指导书、实践指导书。
            <br />（3）需要将博努力提供的课程产品引入专业培养方案或课程体系的实施方案，最少开展一年的实际教学应用。并向博努力提供软件改进的意见及项目建设周期外的后续应用规划，总结教学应用经验、探索实验教学队伍考核、奖励、监督机制、教学效果评价办法等，提交使用分析报告。
            <br />（4）博努力对所开发课程成果不拥有任何知识产权。项目支持的所有课程资源均要求在学校自己网站上进行共享，且可给其他所有学校免费使用，促进教学资源共享。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              五、支持办法
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;拟支持35项教学内容和课程体系改革项目（包含新能源、数字孪生、能源产品与市场等方向）、5项实践条件和实践基地建设项目项目。建设周期均从立项日期起为期一年。
            <br />
            <br />（1）经费：博努力拟对入选的教学内容和课程体系改革项目提供每项不少于5万元人民币经费支持，拟对入选的实践条件和实践基地建设项目提供每项价值不少于20万元的产品支持。
            <br />（2）博努力（北京）仿真技术有限公司将为立项项目提供必要的支持。在项目开展的一年期内，保持双向沟通和交流，促进建设项目的顺利进行。
            <br />（3）博努力（北京）仿真技术有限公司将在项目结束之际，组织项目评审，并且对项目进行总结，巩固建设成果，为公开共享建设成果做好必要准备。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              六、申请办法
            </div>
            （1）申报者应在产学合作协同育人平台（http://cxhz.hep.com.cn）注册教师用户，填写申报相关信息，并下载《2022年博努力（北京）仿真技术有限公司教育部产学合作协同育人项目申报书》进行填写。
            <br />（2）项目申报人须在平台项目申报截止时间前将加盖高校校级主管部门公章的申请书形成PDF格式电子文档（无需提供纸质文档）上传至平台。若有任何疑问，请与企业项目负责人联系。
            <br />
            <p>企业项目负责人：许加达</p>
            <p>电话：13466405155</p>
            <p>邮箱：bernouly@126.com</p>
            （3）博努力（北京）仿真技术有限公司将于项目申报结束后组织专家进行项目评审，并及时公示入选项目名单。
            <br />（4）博努力（北京）仿真技术有限公司将与项目申报负责人所在高校签署立项项目协议书。立项项目周期为1年，所有工作应在立项项目协议书约定的项目周期内完成。项目到期后，项目负责人通过项目平台提交结题报告及项目成果，博努力（北京）仿真技术有限公司公司将对项目进行验收。
            <br />（5）有关本项目申报相关信息及资料也可在博努力（北京）仿真技术有限公司官网（www.bernouly.com）“协同育人”板块获取。
          </div>
        </div>
        <div v-if="radoFlag == 4" class="certificate-info">
          <div class="r_title">
            <p style="white-space: nowrap">
              2024年博努力（北京）仿真技术有限公司
            </p>
            <p>&nbsp;&nbsp;教育部产学合作协同育人项目申报指南</p>
          </div>
          <div
            class="content"
            style="
              font-size: 16px;
              margin-top: 57px;
              color: #777777;
              font-family: siyuanx;
              text-indent: 43px;
              line-height: 37px;
            "
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;博努力（北京）仿真技术有限公司是以计算机数值模拟仿真技术、虚拟现实技术和网络技术为核心，面向电力、能源、化工、建材等工业领域，提供工艺系统仿真、控制系统设计验证、职业技能培训、虚拟实验开发、数字化教学资源库建设等整体解决方案的高新技术企业，致力于虚拟仿真、数字孪生、云计算等技术在高校实验室建设中的应用与推广。博努力被教育部批准为1+X垃圾焚烧发电运行与维护、发电集控运维职业技能培训评价组织。截止到2023年，博努力（北京）仿真技术公司已达成合作院校100余所，培训学生12万余人，培训师资800余人。
            <br />
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024年博努力提供经费及软硬件支持总价值700万元，拟在“新能源”、“数字孪生”、“能源产品与市场”领域与高校展开紧密合作，具体内容如下：
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              一、建设目标
            </div>

            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在教育部高教司指导下，开展产学合作协同育人项目，包含教学内容和课程体系改革项目大类。
            <br />
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;教学内容和课程体系改革项目围绕新能源领域的热点技术，包括风力、光伏发电、氢能发电、综合能源站、储能系统、制冷、制热、分布式发电、智能微电网、数字孪生、能源产品与市场、新材料、建材绿色生产等课程方向，不断优化课程体系，提升教学质量，培养适应产业发展需要的具有创新精神和实践能力的高质量、复合型人才，建成一批高质量、可共享的虚拟仿真实验教学方案、课程教案和教学改革方案。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;实践条件和实践基地建设项目围绕“虚拟仿真实验资源平台”、“多学科仿真平台”，支持高校学生进行针对风力、光伏发电、氢能、分布式发电、智能微电网、数字孪生、能源产品与市场、建材绿色生产等方向的仿真算法研究，联合高校建设“校企共建虚拟仿真实验教学中心”、打造“国家级虚拟仿真实验教学一流课程”，开展相应领域的虚拟仿真实验教学内容共同研发活动。校企推动重新构建相关课程实验教学内容，优化实践体系，丰富培养方案，提升育人质量，推动高校应用型、创新型、复合型人才培养。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              二、项目内容
            </div>

            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （一）教学内容和课程体系改革项目
            </div>
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;拟设立30个项目，面向国内本科高校新能源、数字孪生、能源产品与市场、建材绿色生产专业，包含风力、光伏发电、氢能发电、综合能源站、储能系统、制冷、制热、分布式发电、智能微电网、数字孪生、能源产品与市场、新材料、建材绿色生产等课程方向，开展新能源及数字孪生虚拟仿真实验教学课程设计与应用项目建设。根据对应专业的培养计划提供虚拟仿真实验教学课程建设内容、功能需求分析、编写实验脚本、教学设计、软件修改或优化改进意见、实验指导书编写、专业咨询等工作，支持教学方式方法创新与改革，分享教学改革经验和实践做法，形成相应的虚拟实验系统、教学软件、教材、课程、方案等资源。方向及内容最好为真实实验无法开展、存在困难、难以达到教学效果的实验，促进相关专业与企业合作重新构建有专业深度的教学内容，优化实验教学体系，拉近产学距离，提升育人质量。
            <br />

            <br />
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （二）实践条件和实践基地建设项目
            </div>
            <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;拟设立5个项目，专业方向面向国内本科高校新能源、数字孪生、能源产品与市场、建材绿色生产专业，用于建设基于互联网的虚拟实验在线自主开发平台及实验项目。由博努力提供相关专业课程的虚拟仿真教学或实验软件及管理平台，联合高校共建共管虚拟仿真实验教学中心，开展相应课程虚拟仿真实验教学应用，重构和优化相关课程实验教学内容，校企联合制定实验教学培养方案，提升育人质量，推动高校相关专业应用型、创新型、复合型人才培养。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              三、申报条件
            </div>

            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （一）教学内容和课程体系改革项目
            </div>
            <br />（1）教师提供课程体系结构，知识体系，课程内容，典型教学案例。面向高校新能源、数字孪生、能源产品与市场、建材绿色生产方向的本科院系，由高校各学科建设团队自由申报。
            <br />（2）确保有足够时间按时完成项目建设和交付，有志于进行教学内容改革、完善课程体系，并进行过类似研究，或已经有完善的研究计划，能够代表该课程在行业内容最新发展方向。
            <br />（3）院校领导大力支持推进高校课程综合改革，申报单位和企业按比例投入配套相关经费用于项目建设。
            <br />（4）项目申报人为本科实验教学课程负责人。
            <br />（5）申报课程应以现有课程为基础，不接受之前没有开课基础的课程申报。同等条件下，优先考虑受益面大的课程申报。
            <br />
            <br />
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （二）实践条件和实践基地建设项目
            </div>
            <br />（1）教师团队提供课程体系结构，知识体系，课程内容，典型教学案例。面向高校新能源、数字孪生、能源产品与市场、建材绿色生产方向的本科院系，由高校各学科建设团队自由申报。
            <br />（2）申报高校应具备与课程配套的相关实训实验环境或具备相关领域算法方面的课题研究经验。
            <br />（3）优先考虑国家级或省级实验教学示范中心/虚拟仿真实验教学中心的申报单位。
            <br />注意：每位老师请申报上述项目中的一项，不鼓励多项申报。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              四、建设要求
            </div>
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （一）教学内容和课程体系改革项目
            </div>
            <br />（1）成果须包含课程内容和典型教学案例两部分，形成完整的项目建设内容，且明确注明可公开、可共享。
            <br />（2）课程大纲，包括具体的课程时间分配、实验原理、实验方法、实验步骤描述；
            <br />（3）教师授课教案：每章节均提供PPT课件。提供课程相关的参考书目、论文参考文献、网络资源等内容；
            <br />（4）典型教学案例：围绕课程教学内容，开发5个典型教学案例。
            <br />（5）教改方案或执行报告，可以以论文形式呈现；所有数字资源，包含.doc或.ppt形式的文件；若有源代码，请给出源代码文件。
            <br />（6）博努力对所开发课程成果不拥有任何知识产权。项目支持的所有课程资源均要求在学校自己网站上进行共享，且可给其他所有学校免费使用，促进教学资源共享。
            <br />
            <br />
            <div style="color: #777777; font-size: 14px; font-weight: Medium">
              （二）实践条件和实践基地建设项目
            </div>
            <br />（1）校方应具备不少于 30 人同时做实验的实验基地。
            <br />（2）基于博努力公司的多学科仿真平台，提供实验手册或实验指导书、实践指导书。
            <br />（3）需要将博努力提供的课程产品引入专业培养方案或课程体系的实施方案，最少开展一年的实际教学应用。并向博努力提供软件改进的意见及项目建设周期外的后续应用规划，总结教学应用经验、探索实验教学队伍考核、奖励、监督机制、教学效果评价办法等，提交使用分析报告。
            <br />（4）博努力对所开发课程成果不拥有任何知识产权。项目支持的所有课程资源均要求在学校自己网站上进行共享，且可给其他所有学校免费使用，促进教学资源共享。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              五、支持办法
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;拟支持30项教学内容和课程体系改革项目（包含新能源、数字孪生、能源产品与市场等方向）。建设周期均从立项日期起为期一年。
            <br />
            <br />（1）经费：博努力拟对入选的教学内容和课程体系改革项目提供每项不少于5万元人民币经费支持和价值15万元的仿真教学系统开发平台软件支持。
            <br />（2）博努力（北京）公司将为立项项目提供必要的支持。在项目开展的一年期内，保持双向沟通和交流，促进建设项目的顺利进行。
            <br />（3）博努力（北京）公司将在项目结束之际，组织项目评审，并且对项目进行总结，巩固建设成果，为公开共享建设成果做好必要准备。
            <br />
            <br />
            <div style="color: black; font-size: 15px; font-weight: bold">
              六、申请办法
            </div>
            （1）申报者应在产学合作协同育人平台（http://cxhz.hep.com.cn）注册教师用户，填写申报相关信息，并下载《2024年博努力（北京）仿真技术有限公司教育部产学合作协同育人项目申报书》进行填写。
            <br />（2）项目申报人须在平台项目申报截止时间前将加盖高校校级主管部门公章的申请书形成PDF格式电子文档（无需提供纸质文档）上传至平台。若有任何疑问，请与企业项目负责人联系。
            <br />
            <p>企业项目负责人：许加达</p>
            <p>电话：13466405155</p>
            <p>邮箱：bernouly@126.com</p>
            （3）博努力（北京）仿真技术有限公司将于项目申报结束后组织专家进行项目评审，并及时公示入选项目名单。
            <br />（4）博努力（北京）仿真技术有限公司将与项目申报负责人所在高校签署立项项目协议书。立项项目周期为1年，所有工作应在立项项目协议书约定的项目周期内完成。项目到期后，项目负责人通过项目平台提交结题报告及项目成果，博努力（北京）仿真技术有限公司公司将对项目进行验收。
            <br />（5）有关本项目申报相关信息及资料也可在博努力（北京）仿真技术有限公司官网（www.bernouly.com）“协同育人”板块获取。
          </div>
        </div>

        <div v-if="radoFlag == 2" class="certificate-info">
          <el-table
            :data="tableData"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
            border
            style="width: 100%"
          >
            <el-table-column
              fixed
              prop=""
              label="序号"
              :formatter="nShowIndex"
              width="50"
            >
            </el-table-column>
            <el-table-column fixed prop="school" label="院校" width="250">
            </el-table-column>
            <el-table-column prop="teacher" label="教师" width="120">
            </el-table-column>
            <el-table-column prop="project" label="项目名称" width="400">
            </el-table-column>
            <el-table-column fixed="right" label="成果展示" width="140">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="radoFlag == 3" class="certificate-info">
          <el-table
            :data="tableData"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
            border
            style="width: 100%"
          >
            <el-table-column
              fixed
              prop=""
              label="序号"
              :formatter="nShowIndex"
              width="50"
            >
            </el-table-column>
            <el-table-column fixed prop="school" label="院校" width="250">
            </el-table-column>
            <el-table-column prop="teacher" label="教师" width="120">
            </el-table-column>
            <el-table-column prop="project" label="项目名称" width="400">
            </el-table-column>
            <el-table-column fixed="right" label="成果展示" width="140">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Article, ArChildren } from "../services/article";
export default {
  components: {},
  data() {
    return {
      activeName: 0,
      schoolIndex: 1,
      schoolItem: 1,
      school: [],
      cateIndex: 0,
      certificateIndex: 0,
      radoFlag: 0,
      pindex: 0,
      kg: false,
      /**
       * 一级分类子菜单
       * cate_id:分类子菜单id
       * name:分类子菜单名称
       * 测试数据 部署时清空
       */
      dataList: [],

      certificateItems: [
        {
          name: "申报指南",
          isSubShow: true,
          subItems: [
            {
              name: "2021年",
            },
            {
              name: "2022年",
            },
            {
              name: "2024年",
            },
          ],
        },
        {
          name: "课程成果展示",
          isSubShow: false,
          subItems: [
            {
              name: "2021年",
            },
            {
              name: "2022年",
            },
          ],
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    // this.menuClick();
  },
  watch: {},
  created() {},
  methods: {
    // 表格序号的返回方法
    nShowIndex(row, column, cellValue, index) {
      return index + 1;
    },
    // 查看成果展示的方法
    handleClick(row) {
      console.log(row);
      if (row.content == null || row.content.length < 100) {
        this.$message({
          message: "更新中,请及时关注!",
          offset: 400,
          type: "warning",
          center: true,
        });
      } else {
        this.$router.push({
          path: "/synergy-active",
          query: {
            id: row.id,
          },
        });
      }
    },
    showToggle: function (item) {
      console.log(item);
      this.pindex = item;
      item.isSubShow = !item.isSubShow;
      if (item.name == "申报指南") {
        this.rdio(0);
        this.certificateItems[1].isSubShow = false;
      } else {
        this.rdio(2);
        this.certificateItems[0].isSubShow = false;
      }
    },
    //   证书信息 显示学校信息
    certificate(index) {
      if (index == 3) {
        this.school = this.school1;
      }
      this.certificateIndex = index;
    },
    //证书信息-对应要求-翻页
    certificatepagetap(n) {
      if (n == 1) {
        this.schoolIndex = 1;
        this.school = this.school1;
      } else if (n == 2) {
        this.schoolIndex = 2;
        this.school = this.school2;
      } else {
        this.schoolIndex = 3;
        this.school = this.school3;
      }
    },

    catepagetap(n) {
      if (n == 1) {
        this.schoolItem = 1;
        this.school = this.school4;
      } else if (n == 2) {
        this.schoolItem = 2;
        this.school = this.school5;
      } else if (n == 3) {
        this.schoolItem = 3;
        this.school = this.school6;
      } else {
        this.schoolItem = 4;
        this.school = this.school7;
      }
    },

    certificatepageto() {
      if (this.schoolIndex == 1) {
        this.schoolIndex = 2;
        this.school = this.school2;
      } else if (this.schoolIndex == 2) {
        this.schoolIndex = 3;
        this.school = this.school3;
      } else if (this.schoolIndex == 3) {
        this.schoolIndex = 1;
        this.school = this.school1;
      }
    },
    catepageto() {
      if (this.schoolItem == 1) {
        this.schoolItem = 2;
        this.school = this.school5;
      } else if (this.schoolItem == 2) {
        this.schoolItem = 3;
        this.school = this.school6;
      } else if (this.schoolItem == 3) {
        this.schoolItem = 4;
        this.school = this.school7;
      } else if (this.schoolItem == 4) {
        this.schoolItem = 1;
        this.school = this.school4;
      }
    },
    //证书信息-对应要求-下一页
    kgc() {
      if (this.kg) {
        this.kg = false;
      } else {
        this.kg = true;
      }
    },

    //初中高级证书简介--切换
    rdio(index) {
      this.radoFlag = index;
      if (index == 0) {
        this.pindex = 0;
      } else if (index == 1) {
        this.pindex = 0;
      } else if (index == 4) {
        this.pindex = 0;
      } else if (index == 2) {
        this.pindex = 1;
        this.article(185);
      } else if (index == 3) {
        this.pindex = 1;
        this.article(186);
      }
    },

    // 请求获取文章列表
    article(cid) {
      this.tableData = [];
      var arr = [];
      Article({
        category_id: cid,
        pageSize: 100, //参数是pageSize
        page: 1,
      }).then((res) => {
        if (res.items.length > 0) {
          res.items.forEach((item) => {
            arr = item.name.split("_"); // 截取字符串  (学院名称  / 教师  /  项目)
            item.school = arr[0];
            item.teacher = arr[1];
            item.project = arr[2];
            this.tableData.push(item);
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.partner {
  background-color: white;
}
.certificate-list {
  width: 1200px;
  min-height: 450px;
  margin: 0 auto;
  padding: 0 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}
.certificate-list-left {
  float: left;
  width: 185px;
}
.toobar {
  height: 78px;
  padding-top: 30px;
  border-bottom: 1px solid #6d5c55;
}

.eng {
  font-size: 16px;
  color: #666666;
}

.eng-font {
  font-size: 26px;
}

.content p {
  font-weight: bold;
}
.column1 {
  height: 52px;
  width: auto;
  font-size: 18px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  border-top: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
  color: #61666c;
}
.column2 {
  height: 52px;
  width: auto;
  font-size: 18px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  border-top: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  background-color: #306bbb;
  color: #fff;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}
.column1:hover {
  color: #0055d3;
  cursor: pointer;
}
.column2:hover {
  cursor: pointer;
}
.certificate-list-right {
  position: relative;
  display: inline-block !important;
  width: 1014px;
  height: auto;
  border-left: 1px solid #d4d4d4;
}
.certificate-info {
  min-height: 450px;
  margin-top: 50px;
  margin-left: 50px;
  margin-bottom: 136px;
}
.r_title {
  width: 544px;
  height: 71px;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  line-height: 42px;
  margin-top: 43px;
  margin-left: 206px;
  margin-bottom: 57px;
}
.certificate-menu {
  width: 1190px;
  background: #fff;
  position: absolute;
  top: 410px;
  height: 80px;
  left: 50%;
  margin-left: -600px;
}
.rado {
  height: 36px;
  display: inline-block;
  margin-left: 10px;
  background: url(../assets/xuanzhzong_1.png) no-repeat 12px 12px;
  line-height: 36px;
  padding-left: 30px;
  margin-left: 0px;
  font-size: 16px;
  font-weight: 500;
}
.rado1 {
  height: 36px;
  display: inline-block;
  margin-left: 10px;
  background: url(../assets/xuanzhong.png) no-repeat 12px 12px;
  line-height: 36px;
  padding-left: 30px;
  margin-left: 0px;
  font-size: 16px;
  font-weight: 500;
  color: #0055d3;
}
.certificate-info-menu {
  color: #666666;
  height: 80px;
}

.certificate-info-menu ul {
  display: flex;
}

.certificate-info-menu li {
  width: 100px;
  cursor: pointer;
  height: 80px;
  font-size: 16px;
  text-align: center;
  line-height: 80px;
}

.hr {
  height: 4px;
  background: #ededed;
}

.certificate-info-content {
  line-height: 30px;
  margin-top: 40px;
  margin-bottom: 100px;
  color: #666666;
}

.certificate-info-content3 {
  margin-top: 40px;
  height: 574px;
  color: #666666;
}

.certificate-info-content3 tr {
  height: 50px;
  background: #eaf2ff;
}

.certificate-info-content3 tr:nth-child(2n + 1) {
  background: #fafafa;
}

.kai {
  transform: rotate(-90deg);
}
.title-page .box {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin-right: 2px;
  font-size: 16px;
  color: #333;
  background: #ddd;
}
.box:hover {
  cursor: pointer;
}

.title-page .flex {
  display: flex;
}

.title-page .active {
  color: #fff;
  background: #0055d3;
}

.title-page-active:active {
  background: #0055d3;
  color: #fff;
}
</style>